import { render, staticRenderFns } from "./Pareto.vue?vue&type=template&id=366ac6e6"
import script from "./Pareto.vue?vue&type=script&lang=js"
export * from "./Pareto.vue?vue&type=script&lang=js"
import style0 from "./Pareto.vue?vue&type=style&index=0&id=366ac6e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports